import { Box, Button, Menu, MenuButton, MenuItem, MenuList, Text } from "@chakra-ui/react";
import { GoChevronRight, GoOrganization } from "react-icons/go";

import { useOrganizationSwitcher } from "hooks/use-organization-switcher";

type Props = {
  isAccountSettings?: boolean;
  isHub?: boolean;
};

export default function OrganizationSwitcher({ isAccountSettings, isHub }: Props) {
  const { storageData, organizations, loading, handleOrganizationChange } =
    useOrganizationSwitcher();

  return storageData && organizations.length > 1 ? (
    <Box>
      <Menu>
        <MenuButton
          textAlign="left"
          as={Button}
          colorScheme={isAccountSettings ? "brand.gray" : ""}
          variant={isAccountSettings ? undefined : "unstyled"}
          bg={isAccountSettings ? undefined : "transparent"}
          size="sm"
          isLoading={loading}
          alignItems="center"
          display="flex"
          leftIcon={<GoOrganization color="special.desktopSidebarText" />}
          rightIcon={
            <Box display={isHub ? { base: "none", md: "block" } : "block"}>
              <GoChevronRight color="special.desktopSidebarText" />
            </Box>
          }
          color={isHub ? "white" : "special.desktopSidebarText"}
        >
          <Text
            w={"120px"}
            textAlign="left"
            style={{
              textWrap: "balance",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {organizations.find((org) => org.id === storageData)?.name || "Select Organization"}
          </Text>
        </MenuButton>
        <MenuList zIndex={20} maxH="300px" overflowY="auto">
          {organizations.map((org) => (
            <MenuItem
              role="menuitem"
              key={org.id}
              onClick={() => handleOrganizationChange(org.id)}
              style={{ textWrap: "balance", color: "black" }}
            >
              {org.name}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  ) : null;
}
